import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { ConfigModule } from 'Angular/config/config.module';
import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import { MetricSelectorModalModule } from 'CalculationsApp/ts/features/metric-selector-modal/metric-selector-modal.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import * as i0 from "@angular/core";
export class KeyStatsModalModule {
}
KeyStatsModalModule.ɵfac = function KeyStatsModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || KeyStatsModalModule)(); };
KeyStatsModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: KeyStatsModalModule });
KeyStatsModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule,
        CommonModule,
        ConfigModule,
        FeatureNeededModule,
        IconModule,
        MetricSelectorModalModule,
        ModalBaseModule,
        TooltipModule] });
